module.exports = __webpack_public_path__ + "static/media/contact.077ef780.png";